export type ClosedLine = 7 | 8;
export type FilterLine = ClosedLine | undefined;
export type MutatingLine = 9 | 6;
export type Line = ClosedLine | MutatingLine;
export type EvolvingLine = ClosedLine | MutatingLine | undefined;

export const matches = (line: EvolvingLine, main: ClosedLine): boolean =>
  (main === 7 && (line === 7 || line === 9)) ||
  (main === 8 && (line === 8 || line === 6));
